import React from 'react';

class DisplayError extends React.Component{
    render(){
        return(
            <React.Fragment>
                {this.props.errorVisible ? 
                    <div style = {{marginLeft:10,marginTop:30}} >
                        <p className="alert alert-danger text-danger">{this.props.errorDesc}</p>
                    </div>
                    :''

                    }
            </React.Fragment>
        )
    }
}

export default DisplayError;


// WEBPACK FOOTER //
// ./src/DisplayError.jsx